import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import _ from "lodash";
import cx from "classnames";

import styles from "./createDomain.module.scss";
import { Dropdown, Form, Grid, Modal } from "semantic-ui-react";

import SaveChanges from "components/ui/Buttons/SaveButton";
import Cancel from "components/ui/Buttons/CancelButton";
import {createCleverstoryDomain,updateCleverstoryDomain} from "actions/cleverstory";

import { useParams, useLocation } from "react-router-dom";

const initDomain = {
  url: ""
};

const initErrorFields = [
  {
    name: "url",
    title: "Url",
    error: false,
    message: null,
  },
];

export default function CreateDomain({ account, domain, open, setOpen }) {
  const dispatch = useDispatch();

  const [initialRendering, setInitialRendering] = useState(true);
  const [domainDetail, setDomainDetail] = useState(initDomain);
  const [error, setError] = useState(null);
  const [errorFields, setErrorFields] = useState(initErrorFields);
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const creatingDomain = useSelector((state) => _.get(state, "cleverstoryDomains.createDomain"));
  const updatingDomain = useSelector((state) => _.get(state, "cleverstoryDomains.updateDomain"));

  const location = useLocation();

  useEffect(() => {
    setDomainDetail(domain ? { ...domain } : { ...initDomain });
    setErrorFields([...initErrorFields]);
    setError(null);
    setFormSubmitted(false);
  }, [open]);

  useEffect(() => {
    validateFields();

    if (isFormSubmitted) {
      // reset form if user trying to resets the value
      setFormSubmitted(false);
    }
  }, [domainDetail]);

  useEffect(() => {
    if (!initialRendering && creatingDomain && !creatingDomain.creating) {
      if (creatingDomain.success) {
        setOpen(false);
        toast.success(`created successfully`, {
          toastId: "created"
        });
      } else if (creatingDomain.error) {
        setError(creatingDomain.error);
      }
    }
  }, [creatingDomain]);

  useEffect(() => {
    if (!initialRendering && updatingDomain && !updatingDomain.creating) {
      if (updatingDomain.success) {
        setOpen(false);
        toast.success(`updated successfully`, {
          toastId: "updated"
        });
      } else if (updatingDomain.error) {
        setError(updatingDomain.error);
      }
    }
  }, [updatingDomain]);

  useEffect(() => {
    let message = null;
    for (var i = 0; i < errorFields.length; i++) {
      if (errorFields[i].error) {
        message = errorFields[i].message;
        break;
      }
    }

    setError(message);
  }, [errorFields]);

  setTimeout(() => {
    setInitialRendering(false);
  }, 3000);

  const isFieldError = (fieldName) => {
    let error = false;
    if (isFormSubmitted) {
      errorFields.forEach((field, idx) => {
        if (field.name === fieldName && field.error) {
          error = true;
        }
      });
    }

    return error;
  };

  const isFormValid = () => {
    let errors = errorFields.filter((item) => item.error);
    if (errors.length > 0) return false;

    return true;
  };

  const validateFields = () => {
    let fields = [];
    for (var i = 0; i < errorFields.length; i++) {
      let field = errorFields[i].name;
      let value = domainDetail[field];

      errorFields[i].error =
        value === null || value === undefined ? true : false;

      if (!value) {
        errorFields[i].error = true;
        errorFields[i].message = errorFields[i].title + " is required";
      } else {
        errorFields[i].error = false;
        errorFields[i].message = null;
      }

      if(field === "url" && value) {
        let valid = validUrl(value);
        if(!valid) {
          errorFields[i].error = true;
          errorFields[i].message = "Please enter a valid url";
        }
      }

      fields.push(errorFields[i]);
    }

    setErrorFields(fields);
  };


  const validUrl = (str) => {
    const pattern = /^https:\/\/[^\s/$.?#].[^\s]*$/;
    return pattern.test(str);
  }

  const onCreateDomain = (e) => {
    e.preventDefault();

    if (e.type === "submit") {
      setFormSubmitted(true);

      if (isFormValid()) {
        if (domain) {
          dispatch(
            updateCleverstoryDomain({
              workspaceId: location.state.workspaceId,
              domainId: domain.id,
              data: {
                url: domainDetail.url
              }
            })
          );
        } else {
          dispatch(
            createCleverstoryDomain({
              id: location.state.workspaceId,
              data: {
                url: domainDetail.url,
                primary: false
              },
            })
          );
        }
      }
    }
  };

  const renderContent = () => {
    if (domain) {
      return updatingDomain && updatingDomain.updating ? "Updating" : "Update";
    }
    return creatingDomain && creatingDomain.creating ? "Creating" : "Create";
  };

  return (
    <>
      <Modal
        size="tiny"
        open={open}
        centered
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        className={cx(styles.create)}
      >
        <Modal.Content className={cx(styles.content)}>
          <Form onSubmit={onCreateDomain}>
            <Grid>
              <Grid.Row>
                <Grid.Column textAlign="center">
                  <span className={cx(styles.title)}>
                    {domain ? "Update Domain" : "Create Domain"}{" "}
                  </span>
                </Grid.Column>
              </Grid.Row>
              {/* <Grid.Row>
                <Grid.Column>
                  <Form.Input
                    fluid
                    id="cloudfrontDistribution"
                    label={"Cloud Front Distribution"}
                    placeholder="Cloud Front Distribution"
                    value={domainDetail.cloudfrontDistribution}
                    onChange={(e) =>
                      setDomainDetail({
                        ...domainDetail,
                        cloudfrontDistribution: e.target.value,
                      })
                    }
                    error={isFieldError("cloudfrontDistribution")}
                  ></Form.Input>
                </Grid.Column>
              </Grid.Row> */}

              <Grid.Row>
                <Grid.Column>
                  <Form.Input
                    fluid
                    id="url"
                    label={"Url"}
                    placeholder="Url"
                    value={domainDetail.url}
                    onChange={(e) =>
                      setDomainDetail({
                        ...domainDetail,
                        url: e.target.value,
                      })
                    }
                    error={isFieldError("url")}
                  ></Form.Input>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  {isFormSubmitted && (
                    <div className={cx(styles.error)}> {error}</div>
                  )}
                </Grid.Column>
                <Grid.Column textAlign="right">
                  <SaveChanges content={renderContent()} type="submit" />
                  <Cancel content="Cancel" onClick={() => setOpen(false)} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
      </Modal>
    </>
  );
}
